<template>

    <div id="mobile-navigation" :class="{shown: visible}">

        <div class="mobile-header">
            <img src="../assets/img/icon/menu-white.png" v-if="!visible" class="nav-icon" @click="toggleMenu()">
            <img src="../assets/img/icon/close-white.png" v-if="visible" class="nav-icon" @click="toggleMenu()">
            <div class="middle">
                <svgicon src="icon/logo-ishopfood.svg" :height="20"></svgicon>
                <svgicon src="icon/logo-payfacto.svg" :height="15"></svgicon>
            </div>
            <div>
                <ActionMenu icon="/icon/gear-white.png">
                    <div href="javascript:void(0)" class="item locale">
                        <span v-for="locale in $ts.getters.getLocales" :key="locale"
                              :class="{active: $ts.state.locale === locale}"
                              @click="$ts.commit('setLocale', locale)">
                            {{ locale.toUpperCase() }}
                        </span>
                    </div>
                    <a href="javascript:void(0)" class="item" @click="logout">{{$t("logout")}}</a>
                    <PayfactoSupportUrl class="item"></PayfactoSupportUrl>
                    <a :href="$to(Parameters.urlSupport)" class="item" target="_blank">{{$t("faq.short")}}</a>
                </ActionMenu>
            </div>
        </div>

        <div id="mobile-menu" :class="{hidden: !visible}">
            <Navigation @close-menu="closeMenu()"/>
        </div>

    </div>

</template>

<script>

  import ActionMenu from "./tools/ActionMenu.vue";
  import Navigation from './Navigation.vue';
  import PayfactoSupportUrl from "@/components/PayfactoSupportUrl.vue";

  export default {

    name: "MobileNavigation",

    components: {
      Navigation,
      ActionMenu,
      PayfactoSupportUrl
    },

    data() {
      return {
        Parameters,
        visible: false
      }
    },

    methods: {
      toggleMenu() {
        this.visible = !this.visible;
      },
      closeMenu() {
        this.visible = false;
      },
      logout() {
        this.$store.commit('logOut');
        this.$router.push("/login");
      }
    }
  };

</script>

<style lang="scss" scoped>
    #mobile-navigation {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 10;
        display: flex;
        flex-direction: column;
        &.shown {
            height: 100%;
        }
    }
    #mobile-menu {
        z-index: 2;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        &.hidden {
            display: none;
        }
    }
    #navigation {
        flex-grow: 1;
    }
    .mobile-header {
        background-color: #FC6650;
        display: flex;
        align-items:center;
        justify-content: space-between;
        height: 56px;
        flex-shrink: 0;
        fill: white;

        .mobile-logo {
            height: 34px;
        }
        .nav-icon {
            margin: 20px;
            cursor: pointer;
            width: 25px;
            height: 25px;
            fill: white;
        }
        .locale {
            display: flex;
            justify-content: space-around;
            .active {
                font-weight: bold;
            }
        }
        .middle {
            display: flex;
            align-items: center;
            .svgicon:first-child {
                margin-right: 0;
                &::after {
                    content: '';
                    display: block;
                    width: 1px;
                    height: 16px;
                    background-color: white;
                    margin: 0 16px;
                }
            }
        }
    }
</style>

<style lang="scss">
    .mobile-header .action.menu {
        img {
            margin: 20px;
            height: 25px;
        }
    }
    #mobile-navigation .support-btn {
        max-width: 160px;
        display: block;
        line-height: 1;
    }
</style>
